import { useEffect } from 'react';

interface ISelectedPeriodLike {
  categoryId: string | null,
  subCategoryId: string | null,
  dateFrom: number | null,
}

export const useScrollToDeals = (selectedPeriod: ISelectedPeriodLike, elRef: React.RefObject<HTMLElement>) => {
  useEffect(() => {
    if (selectedPeriod.categoryId && elRef.current) {
      elRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [selectedPeriod.categoryId, selectedPeriod.subCategoryId, selectedPeriod.dateFrom, elRef]);
};
